import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../../../../UserContext';
import './Subscription.css';
import { subscriptionService } from '../../../../services';

const SubscriptionSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { fetchUserProfile } = useUser();
    const [message, setMessage] = useState('Confirming your subscription and updating your account...');
    const [error, setError] = useState(null);

    useEffect(() => {
        let redirectTimer;

        const syncSubscription = async () => {
            const sessionId = searchParams.get('session_id');

            try {
                if (sessionId) {
                    await subscriptionService.getCheckoutSession(sessionId);
                }

                await fetchUserProfile();
                setMessage('Your premium access is active. Redirecting you to your subscription page...');
            } catch (syncError) {
                console.error('Error syncing subscription:', syncError);
                setError(syncError.message || 'We could not confirm your subscription automatically yet.');
                setMessage('Your checkout completed, but account confirmation may take another moment.');
            } finally {
                redirectTimer = setTimeout(() => {
                    navigate('/dashboard/subscription', { replace: true });
                }, 3500);
            }
        };

        syncSubscription();

        return () => {
            if (redirectTimer) {
                clearTimeout(redirectTimer);
            }
        };
    }, [fetchUserProfile, navigate, searchParams]);

    return (
        <div className="subscription-page">
            <h2>Subscription Successful!</h2>
            <div className="current-subscription">
                <h3>Thank you for subscribing to Premium.</h3>
                <p>{message}</p>
                {error ? <p>{error}</p> : null}
                <p>You will be redirected to your subscription page in a few seconds.</p>
            </div>
            <div className="subscription-tiers">
                <h3>What's Next?</h3>
                <div className="tier-container">
                    <div className="tier">
                        <h4>Enjoy Your Premium Benefits</h4>
                        <ul>
                            <li>Full functionality unlocked</li>
                            <li>Unlimited access to all features</li>
                            <li>Priority support available</li>
                            <li>Advanced analytics at your fingertips</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionSuccess;
